module.exports = __webpack_public_path__ + "static/16-637b6a2294aa4488d2ff3cd008881005.jpg";